import React from 'react';
import { useAuth } from '@contexts/AuthContext';
import { ROLES } from '@app-types';
import { hasRole } from '@utils/permissionUtils';
import DashboardPage from '@pages/DashboardPage';
import AssessorDashboardPage from '@pages/AssessorDashboardPage';
import SchedulerLaunchPage from '@pages/SchedulerLaunchPage';
import ExecutiveDashboardPage from '@pages/ExecutiveDashboardPage';
import ProgramLeadDashboardPage from '@pages/ProgramLeadDashboardPage';
import AdminLaunchPage from '@pages/AdminLaunchPage';
import ContractRoleDashboardPage from '@pages/ContractRoleDashboardPage';

// Dashboard selector based on user role
// Multi-role: Use priority order (Admin > Executive > Program Lead > Contract Role > Assessor > Scheduler > default)
const DashboardSelector: React.FC = () => {
  const { user } = useAuth();

  // Admin sees the Admin launch page, ahead of every other role (ADO-966)
  if (hasRole(user, ROLES.ADMIN)) {
    return <AdminLaunchPage />;
  }

  // Executive takes precedence for dashboard view
  if (hasRole(user, ROLES.EXECUTIVE)) {
    return <ExecutiveDashboardPage />;
  }

  // Program Lead sees dedicated launch page
  if (hasRole(user, ROLES.PROGRAM_LEAD)) {
    return <ProgramLeadDashboardPage />;
  }

  // Contract Role sees the assigned-contracts dashboard
  if (hasRole(user, ROLES.CONTRACT_ROLE)) {
    return <ContractRoleDashboardPage />;
  }

  // Assessor sees assessor dashboard
  if (hasRole(user, ROLES.ASSESSOR)) {
    return <AssessorDashboardPage />;
  }

  // Scheduler sees the scheduling launch page
  if (hasRole(user, ROLES.SCHEDULER)) {
    return <SchedulerLaunchPage />;
  }

  return <DashboardPage />;
};

export default DashboardSelector;
